<template>
  <v-app>
    <v-main>
      <v-container container--fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm4 md3>
            <v-card class="elevation-12">
              <a href="/">
                <img :src="logoPrimary" class="center-block logo">
              </a>
              <v-card-text class="center-block">
                <p class="user-reset">{{user.email}}</p>
                <b-card bg-variant="light">
                  <div v-bind:class="{ 'has-error': ($v.user.password.$error && $v.user.password.$dirty)}">
                    <input class="form-control" @input="$v.user.password.$touch()" type="password" v-model="user.password" placeholder="New Password"/>
                    <div v-if="$v.user.password.$error && $v.user.password.$dirty">
                      <span class="help-block"  v-if="!$v.user.password.required">Please enter new password</span>
                     <span class="help-block"  v-if="!$v.user.password.validPassword" >Password must contain number, uppercase, lowercase, special symbols and more than 8 characters.</span>
                    </div>
                  </div>
                   <div v-bind:class="{ 'has-error': $v.user.repeatPassword.$error && $v.user.repeatPassword.$dirty }">
                  <input
                    @input="$v.user.repeatPassword.$touch()"
                    type="password"
                    v-model="user.repeatPassword"
                    class="margin-top-5 form-control"
                    placeholder="Repeat Password"
                  />
                   <span
              class="help-block"
              v-if="!$v.user.repeatPassword.sameAsPassword && $v.user.repeatPassword.$error"
            >Password is not matched</span>
                   </div>
                  <b-button
                    class="margin-top-5"
                    block
                    type="submit"
                    variant="primary"
                    @click="resetPassword"
                  >Reset Password</b-button>
                </b-card>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import userAPIs from './views/User/userAPIs'
import { required, sameAs } from 'vuelidate/lib/validators'
import { regex } from 'vuelidate/lib/validators/common'
import config from '../config'
// check validity of password (containing lowers, uppers, symbols, number)
const validPassword = regex('validPassword', config.regexPattern.password) // lowercase

export default {
  name: 'ForgotPassword',
  data() {
    return {
      logoPrimary: require('@/assets/Kobe Logo Blue.png'),
      email: null,
      fail: false,
      user: {}
    }
  },
  methods: {
    resetPassword() {
      let data = {
        email: this.$route.params.email,
        token: this.$route.params.token,
        password: this.user.password
      }
      userAPIs.resetPassword(data).then(() => {
        this.$swal({
          title: 'Success',
          text: 'Your password has been changed. Redirect to login page!',
          type: 'success'
        }).then(() => {
          window.location = '/login'
        })
      }).catch((error) => {
        this.$swal({
          title: 'Error',
          text: error.response.data.message,
          type: 'error'
        })
        console.error(error)
      })
    }
  },

  validations: {
    user: {
      password: {
        required,
        validPassword
      },
      repeatPassword: {
        sameAsPassword: sameAs('password')
      }
    }
  },

  beforeCreate() {
    let token = this.$route.params.token
    let email = this.$route.params.email
    if (!token || !email) {
      window.location = '/forgot-password?redirect=fail'
    }
    // userAPIs
    //   .validateTokenResetPassword(email, token)
    //   .then(resp => {
    //     this.user = {
    //       email,
    //       password: '',
    //       repeatPassword: ''
    //     }
    //   })
    //   .catch(err => {
    //     console.error(err)
    //     window.location = '/forgot-password?redirect=fail'
    //   })
  },

  created() {
    this.fail = this.$route.query.redirect
  }
}
</script>

<style>
.margin-top-5 {
  margin-top: 5px;
}
img.logo {
  display: block;
  width: min(260px, 72vw);
  max-width: 260px;
  height: auto;
  margin: 0 auto;
}
.user-reset {
  text-align: center;
  font-size: 20px;
  font-weight: 300;
}
</style>



// WEBPACK FOOTER //
// ResetPasswordPage.vue?67712e58